import { render, staticRenderFns } from "./SchoolRepRank.vue?vue&type=template&id=0833547c&scoped=true&"
import script from "./SchoolRepRank.vue?vue&type=script&lang=js&"
export * from "./SchoolRepRank.vue?vue&type=script&lang=js&"
import style0 from "./SchoolRepRank.vue?vue&type=style&index=0&id=0833547c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0833547c",
  null
  
)

export default component.exports